export const dataGridState = {
  initialState: {
    pagination: { paginationModel: { pageSize: 5 } },
  },
  pageSizeOptions: [5, 10, 25, 50, { value: -1, label: "All" }],
};

export const dataGridStateForDashboard = {
  initialState: {
    pagination: { paginationModel: { pageSize: 5 } },
  },
  pageSizeOptions: [5, 10, 25],
};
